<div class="modal-body">
  <div [ngStyle]="{'max-height': (mainService.resizeInfo.clientHeight - 180) + 'px', 'overflow': 'auto'}">
    @if (isString(object)) {
    @if (isXml(object)) {
    <pre>{{getXmlString(object)}}</pre>
    } @else {
    <pre>{{object}}</pre>
    }
    } @else {
    <ngx-json-viewer [json]="object" [expanded]="!collapsed"></ngx-json-viewer>
    }
  </div>
</div>
<div class="modal-footer">
  <button *ngIf="!isString(object)" type="button" class="btn btn-default" (click)="collapsed = !collapsed">
    <span *ngIf="collapsed"><i class="fas fa-plus"></i></span>
    <span *ngIf="!collapsed"><i class="fas fa-minus"></i></span>
  </button>
  <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">Annuleren</button>
  <button *ngIf="isString(object)" type="button" class="btn btn-info" (click)="copy()"><i class="far fa-copy"></i>
    Kopieer tekst</button>
  <button *ngIf="!isString(object)" type="button" class="btn btn-info" (click)="copy()"><i
      class="far fa-brackets-curly"></i> Kopieer JSON</button>
</div>